/**
 * supabase.functions.invoke() returns a FunctionsHttpError for any non-2xx
 * response, and `data` is then null — so the JSON body our edge functions
 * return (e.g. { error: "email_exists" }) never reaches the caller.
 * These helpers read that body back off the error so we can show a real message
 * instead of "Edge Function returned a non-2xx status code".
 */
export const readFunctionErrorBody = async (
  error: unknown,
): Promise<Record<string, any> | null> => {
  const res = (error as any)?.context;
  if (!res || typeof res.json !== "function") return null;
  try {
    return await res.clone().json();
  } catch {
    try {
      return await res.json();
    } catch {
      return null;
    }
  }
};

/** Best-effort human readable message from a failed edge function call. */
export const functionErrorMessage = async (
  error: unknown,
  fallback: string,
): Promise<string> => {
  const body = await readFunctionErrorBody(error);
  const msg = body?.error ?? body?.message;
  if (typeof msg === "string" && msg.trim() && !/^[a-z_]+$/.test(msg)) return msg;
  const raw = (error as any)?.message;
  if (typeof raw === "string" && raw && !raw.includes("non-2xx")) return raw;
  return fallback;
};
